import i18n from "discourse-common/helpers/i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const FilterForMore = setComponentTemplate(createTemplateFactory(
/*
  
  {{#if @collection.content.shouldShowMoreTip}}
    <div class="filter-for-more">
      {{i18n "select_kit.components.filter_for_more"}}
    </div>
  {{/if}}

*/
{
  "id": "ZeAYYeXy",
  "block": "[[[1,\"\\n\"],[41,[30,1,[\"content\",\"shouldShowMoreTip\"]],[[[1,\"    \"],[10,0],[14,0,\"filter-for-more\"],[12],[1,\"\\n      \"],[1,[28,[32,0],[\"select_kit.components.filter_for_more\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[\"@collection\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/filter-for-more.js",
  "scope": () => [i18n],
  "isStrictMode": true
}), templateOnly());
export default FilterForMore;